import { render, staticRenderFns } from "./ManagerPatientsView.vue?vue&type=template&id=f85629b4&scoped=true"
import script from "./ManagerPatientsView.vue?vue&type=script&lang=js"
export * from "./ManagerPatientsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85629b4",
  null
  
)

export default component.exports